export default "/images/37e876f0c9024cf7fd9fdb039467ca3e.avif";